import React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '../Typography/Typography';
import PropTypes from 'prop-types';

export const CharCounterRoot = styled(Typography)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  lineHeight: 1.1,
  marginTop: theme.spacing(0.25),
  color: theme.palette.text.secondary
}));

const CharCounter = ({ id, count, maxCharLength, ...rest }) => {
  return (
    <CharCounterRoot
      variant="caption"
      data-qa-id="text-field-counter"
      data-qa-for={`${id}-text-field-counter`}
      {...rest}>
      {`${count}${maxCharLength ? '/' + maxCharLength : ''}`}
    </CharCounterRoot>
  );
};

CharCounter.propTypes = {
  count: PropTypes.number.isRequired,
  maxCharLength: PropTypes.number
};

export default CharCounter;
